import { get, writable } from "svelte/store";
import { appManager } from "../../../../AppManager";
import { Dictionary } from "../../../../shared/Dictionary";
import { HashSetString } from "../../../../shared/HashSetString";
import { v4 as uuidv4 } from "uuid";
export class TripsScenarioSegmentWorker {
    constructor(tripsScenarioManager, branchCommitIdStore) {
        this.segments = new Dictionary();
        this.updatesStore = writable({ segments: [], failedAssignments: [] });
        this.tripScenarioId = tripsScenarioManager.getData().id;
        this.branchCommitIdStore = branchCommitIdStore;
        this.id = uuidv4();
    }
    abort() {
        if (typeof this.abortController !== "undefined") {
            this.abortController.abort();
            this.abortController = undefined;
        }
        this.segments = new Dictionary();
        appManager.getBusyWorkManager().isDone(this.id, "TRIPS");
    }
    async refresh() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        const delay = ms => new Promise(res => setTimeout(res, ms));
        try {
            const branchCommitId = get(this.branchCommitIdStore);
            const segmentsInUpdate = new HashSetString([]);
            if (typeof branchCommitId !== "undefined") {
                appManager.getBusyWorkManager().isBusy(this.id, "TRIPS");
                // fetch segments again.
                const accessToken = await appManager.api.getAccessToken();
                let next = await appManager.api.projects.getSegments({
                    accessToken: accessToken,
                    branchCommitId: branchCommitId,
                    tripScenarioId: this.tripScenarioId,
                }, signal);
                while (!signal.aborted) {
                    next.segments.forEach(segment => {
                        this.segments.set(segment.globalId, segment);
                        segmentsInUpdate.set(segment.globalId);
                    });
                    this.updatesStore.set({
                        segments: next.segments.map(x => x.globalId),
                        failedAssignments: next.failedAssignments
                    });
                    if (typeof next.nextTripsCollectionId === "undefined" || next.nextTripsCollectionId === null)
                        break;
                    if (branchCommitId !== get(this.branchCommitIdStore))
                        break;
                    await delay(1000);
                    appManager.getBusyWorkManager().isBusy(this.id, "TRIPS");
                    next = await appManager.api.projects.getSegments({
                        accessToken: accessToken,
                        branchCommitId: branchCommitId,
                        tripScenarioId: this.tripScenarioId,
                        nextTripsCollectionId: next.nextTripsCollectionId,
                    }, signal);
                }
            }
        }
        catch (e) {
            if (signal.aborted) {
                console.debug("aborted");
            }
            else {
                throw e;
            }
        }
        this.abortController = undefined;
        appManager.getBusyWorkManager().isDone(this.id, "TRIPS");
    }
    /**
     * Gets the segment with the given id, if any.
     *
     * @param id The id.
     */
    getSegment(id) {
        return this.segments.get(id);
    }
    /**
     * Gets the store to keep track of updated segments.
     * @returns
     */
    getUpdatedSegmentsStore() {
        return this.updatesStore;
    }
}
